import { render, staticRenderFns } from "./TabCard.vue?vue&type=template&id=662fc3d6&scoped=true"
import script from "./TabCard.vue?vue&type=script&lang=js"
export * from "./TabCard.vue?vue&type=script&lang=js"
import style0 from "./TabCard.vue?vue&type=style&index=0&id=662fc3d6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "662fc3d6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTabItem } from 'vuetify/lib/components/VTabs';
import { VTabs } from 'vuetify/lib/components/VTabs';
installComponents(component, {VIcon,VTabItem,VTabs})
